import BaseService from "../baseService";
class BloqueioPrefeitura extends BaseService {
  constructor(id) {
    const resource = "bloqueio-prefeitura";
    let relationship = {
      logs: "logs"
    };
    super(id, relationship, resource);
  }
}

export default (id) => new BloqueioPrefeitura(id);
